import styled from "styled-components";

export const ButtonsWrapper = styled.div`
  flex: 1;
  justify-content: flext-start;
  margin-left: 2.4rem;
  display: flex;
`;
